/* eslint-disable */
export default {
  title: 'Vastaa ääniviestillä',
  customMessage: 'Mukautettu viesti',
  customMessagePlaceholder: 'Kirjoita mukautettu viesti',
} as const;

// @key: @#@"title"@#@ @source: @#@"Reply with Voice Message"@#@
// @key: @#@"customMessage"@#@ @source: @#@"Custom message"@#@
// @key: @#@"customMessagePlaceholder"@#@ @source: @#@"Type a custom message"@#@
